module.exports = __webpack_public_path__ + "img/超大规律 分布式计算能力.65d882b7.png";